'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var ipns = require('ipns');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var ipns__namespace = /*#__PURE__*/_interopNamespace(ipns);

var validator = {
  func: function func(key, record) {
    return ipns__namespace.validator.validate(record, key);
  }
};

function selector(_k, records) {
  return ipns__namespace.validator.select(records[0], records[1]);
}

exports.selector = selector;
exports.validator = validator;